export default __webpack_public_path__ + "static/media/StepFour.1e560460.png";